import { getImageFromAssetFolder } from "../../../utils/assets";
import { colors } from "../../../theme/colors";
import { useNavigate } from "react-router-dom";

export const resources = [
  {
    title: "Extension, Not Replacement",
    slug: "extension-to-traditional-studies-not-a-replacement",
    description:
      "ZEO enhances traditional studies with tracking, analysis, and guided feedback — boosting productivity and outcomes without replacing teachers.",
    keywords: [
      "traditional education",
      "student productivity",
      "learning tools",
      "guided feedback",
      "education technology",
    ],
    showOnHomaPage: true,
  },
  {
    title: "5 Benefits of Supervised Learning",
    slug: "top-5-benefits-of-guided-learning-over-traditional-methods",
    description:
      "Discover the top 5 benefits of supervised learning — from accountability to confidence — and why guidance outperforms solo self-learning.",
    keywords: [
      "supervised learning",
      "student guidance",
      "accountability in learning",
      "learning benefits",
      "mentorship in education",
    ],
    showOnHomaPage: true,
  },
  {
    title: "Counseling Based on Data, Not Just Random Advice",
    slug: "counseling-based-on-data-not-just-random-advice",
    description:
      "Data-driven counseling gives students clarity and personalized paths while helping teachers and parents make smarter, evidence-based decisions.",
    keywords: [
      "data-driven counseling",
      "student guidance",
      "career clarity",
      "education data",
      "personalized learning",
    ],
    showOnHomaPage: true,
  },
  {
    title: "Why Clarity Matters More Than Content",
    slug: "why-clarity-matters-more-than-content",
    description:
      "More content isn’t the answer. Learn why clarity in learning direction reduces overload, builds confidence, and improves results with ZEO.",
    keywords: [
      "clarity in education",
      "learning direction",
      "student confidence",
      "education overload",
      "structured learning",
    ],
    showOnHomaPage: true,
  },
  {
    title:
      "Why Self-Learning is Broken: and Why Students Need Supervision to Succeed",
    slug: "why-self-learning-is-broken-and-why-students-need-supervision-to-succeed",
    description:
      "Self-learning often fails without supervision. Explore why structured guidance keeps students motivated, focused, and truly successful.",
    keywords: [
      "self-learning challenges",
      "need for supervision",
      "student motivation",
      "structured guidance",
      "learning success",
    ],
  },
  {
    title:
      "Introducing ZeroEqualOne: Personalized Guidance Meets Online Learning",
    slug: "introducing-zeroequalone-personalized-guidance-meets-online-learning",
    description:
      "ZeroEqualOne blends mentorship with self-paced learning. Discover how personalized roadmaps and guidance redefine online education.",
    keywords: [
      "ZeroEqualOne",
      "personalized guidance",
      "online learning",
      "mentorship in education",
      "student success",
    ],
  },
  {
    title: "Why We're Bringing Supervision Back to Online Learning",
    slug: "why-we-are-bringing-supervision-back-to-online-learning",
    description:
      "Supervision is the missing link in online learning. See how Zeo restores structure, accountability, and outcomes for modern learners.",
    keywords: [
      "supervision in online learning",
      "student accountability",
      "online education challenges",
      "structured learning",
      "mentorship",
    ],
  },
  {
    title: "How Zeo Turns Activity into Growth",
    slug: "how-zeo-turns-activity-into-growth",
    description:
      "Zeo converts student activity into insights. From tracking effort to actionable feedback, we turn raw data into measurable growth.",
    keywords: [
      "student activity tracking",
      "learning insights",
      "data-driven learning",
      "education growth",
      "student progress",
    ],
  },
  {
    title: "The Student as an Athlete",
    slug: "student-as-an-athlete",
    description:
      "Students face pressure like athletes, but lack the support system. Learn how athlete-level guidance helps students perform, not just prepare, and reach their true potential.",
    keywords: [
      "student as an athlete",
      "athlete level guidance for students",
      "data driven academic guidance",
      "exam performance optimization",
      "academic performance analytics",
    ],
  },
  {
    title: "Student’s Growth Is More Than Exams",
    slug: "students-growth-more-than-exams",
    description:
      "Student growth goes beyond marks and ranks. Discover how supervision and guided learning bring clarity, confidence, and real progress.",
    keywords: [
      "student growth beyond exams",
      "growth more than exams",
      "learning beyond marks",
      "student supervision in learning",
      "guided learning for students",
      "exam pressure on students",
      "marks vs learning",
      "student academic guidance",
      "supervised learning system",
      "student learning clarity",
      "why exams are not the only measure of success",
      "students need guidance not just content",
      "learning without exam stress",
      "direction in education for students",
      "ZeroEqualOne education",
      "ZEO guided learning",
    ],
  },
  {
    title: "Fixing the Problem from the Root",
    slug: "fixing-the-problem-from-the-root",
    description:
      "Real academic growth comes from fixing root causes, not quick fixes. Learn how supervised guidance builds confidence and clarity over time.",
    keywords: [
      "fixing academic problems from the root",
      "root cause learning guidance",
      "supervised learning for students",
      "academic struggles root cause",
      "learning without quick fixes",
      "student confidence building",
      "mistakes as feedback learning",
      "why students struggle academically",
      "structured supervision in education",
      "learning clarity for students",
      "long term academic growth",
      "guided learning over teaching",
      "ZeroEqualOne education",
      "ZEO student supervision",
    ],
  },
  {
    title: "The Role of Mentorship",
    slug: "role-of-mentorship-in-student-growth",
    description:
      "Mentorship bridges the gap between effort and progress. Discover how guided supervision brings clarity, confidence, and control to student learning.",
    keywords: [
      "role of mentorship in education",
      "importance of mentorship for students",
      "mentorship beyond teaching",
      "guided learning mentorship",
      "student effort vs progress",
      "lack of direction in studies",
      "student burnout and frustration",
      "supervised learning process",
      "self supervised learners",
      "mentorship for academic clarity",
      "student confidence building",
      "learning with guidance",
      "ZeroEqualOne mentorship",
      "ZEO student guidance",
    ],
  },
  {
    title: `The "Illusion of Competence": Why Watching Videos Isn't Learning`,
    slug: "illusion-of-competence-watching-vs-learning",
    description:
      "Watching lectures feels like learning, but real mastery comes from active problem-solving. Discover why passive learning creates the illusion of competence.",
    keywords: [
      "illusion of competence",
      "watching videos is not learning",
      "passive vs active learning",
      "recognition vs recall",
      "why students forget in exams",
      "active problem solving",
      "learning through struggle",
      "exam blank mind problem",
      "self learning mistakes",
      "student study strategy",
      "supervised active learning",
      "ZeroEqualOne supervision",
      "real learning vs passive learning",
    ],
  },
  {
    title: `The Feedback Loop: Why Real-Time Correction Beats Post-Exam Review`,
    slug: "real-time-feedback-vs-post-exam-review",
    description:
      "Post-exam reviews analyze mistakes too late. Discover why real-time feedback and micro-corrections drive faster, smarter academic growth.",
    keywords: [
      "real time feedback in learning",
      "post exam review problems",
      "feedback loop in education",
      "micro corrections in study",
      "student performance supervision",
      "drift detection in learning",
      "exam preparation strategy",
      "fix mistakes before exam",
      "learning efficiency improvement",
      "student time management mistakes",
      "supervised academic growth",
      "ZeroEqualOne feedback system",
      "continuous improvement in studies",
    ],
  },
  {
    title: `Information vs. Transformation: The ZEO Difference`,
    slug: "information-vs-transformation-zeo-difference",
    description:
      "In a world overflowing with information, success depends on discipline and execution. Discover how ZeroEqualOne turns content into real transformation.",
    keywords: [
      "information vs transformation in learning",
      "why information is not enough",
      "content vs discipline education",
      "student study discipline",
      "process driven learning",
      "information abundance problem",
      "why students don't improve",
      "execution in exam preparation",
      "study consistency system",
      "education transformation model",
      "ZeroEqualOne difference",
      "ZEO student supervision",
      "personal trainer for students",
    ],
  },
  {
    title: `The "Busy" Trap: Movement vs. Progress`,
    slug: "busy-trap-movement-vs-progress",
    description:
      "Being busy isn’t the same as making progress. Learn how to escape fake productivity and focus on high-impact actions that actually improve results.",
    keywords: [
      "movement vs progress in studying",
      "busy trap for students",
      "fake productivity in learning",
      "busy vs productive student",
      "high impact study activities",
      "student time wasting habits",
      "dopamine and fake work",
      "how to study effectively",
      "output vs effort in education",
      "productive study system",
      "ZeroEqualOne productivity model",
      "ZEO supervised learning",
      "measure outcome not effort",
    ],
  },
];

const Resources = () => {
  const navigate = useNavigate();
  return (
    <div className="p-16 rounded-xl flex flex-col items-center">
      <h3 className="text-center text-2xl font-semibold" style={{ margin: 0 }}>
        Resources For You
      </h3>
      <p className="text-center text-gray-600" style={{ margin: 0 }}>
        Checkout our articles, techology blogs to understand us better
      </p>
      <div className="flex gap-8 mt-8 justify-center">
        {resources.map((res) => {
          return (
            <div vertical onClick={() => navigate(`/resources/${res.slug}`)}>
              <img
                preview={false}
                src={res.thumbnail}
                style={{ height: "100%", width: "100%", borderRadius: 16 }}
                alt={res.title}
              />
            </div>
          );
        })}
      </div>
      <div id="plans"></div>
    </div>
  );
};

export default Resources;
